module.exports = __webpack_public_path__ + "static/media/wallet.c445ad70.bin";